import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {first} from 'rxjs/operators';
import {TaskService} from '@app/_components/task';
import {AlertService} from '@app/_services';

@Component({
    selector: 'app-task-search',
    templateUrl: './task-search.component.html',
    styleUrls: ['./task-search.component.css'],
    standalone: false
})
export class TaskSearchComponent implements OnInit, OnChanges, AfterViewInit
{
  @Input() selectedTask: any;
  @Input() hideTitle = false;
  @Input() selectedTaskId: any;
  tasks: any[] = [];
  @Output() onTaskSelected = new EventEmitter<any>();
  @Output() onTaskClearedEvent = new EventEmitter<any>();
  @Input() showCreateTask = true;
  @Input() forSearchBar = false;
  constructor(private taskService: TaskService,
              private alertService: AlertService) {
  }
  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
    this.loadSelectedTask();
  }
  reflectFullName(){
  }
  onKeyInput(event)
  {
    let query = event.query;
    this.findTasksWith(query);
    return this.tasks;
  }

  findTasksWith(queryString: string)
  {
    this.taskService.findTasksWith(queryString).pipe(first()).subscribe(

      data =>
      {
        console.log('taskTask serach: ' + JSON.stringify(data));
        this.tasks = [];
        this.tasks = data.data.taskAPIList;
        /*this.tasks.forEach(task => {
        });*/
        // console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }
  taskInfo(event: any){
    this.selectedTask = event;
  }

  onTaskSeleted(task: any) {
    this.selectedTask = task;
    this.emitTaskSelected();
  }
  onTaskCleared(task: any) {
    this.selectedTask = null;
    this.onTaskClearedEvent.emit(this.selectedTask);
  }
  emitTaskSelected(){
    if (this.selectedTask){
      this.onTaskSelected.emit(this.selectedTask);
    }
  }

  private loadSelectedTask() {
    if (this.selectedTaskId) {
      this.taskService.findById(this.selectedTaskId).subscribe(
        res => {
          console.log('task-find SUCCESS: ' + JSON.stringify(res));
          this.selectedTask = res.data.task;
        });
    }
  }
}
